import Swal from 'sweetalert2'

import { userInputFlowSingleHtml } from './userInputFlowSingleHtml'
import {
  makeAjaxCall,
  prepareDropdownLists,
  sweetAlertCommonParams,
  selectedOptionsTextArray,
  createSelect2DynamicOption,
} from '../../functions/utils'
import { lang } from '../../assets/lang'

var page_table_id = window.xitFlowBuilderData.page_table_id
var base_url = window.xitFlowBuilderData.base_url
var instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
const media_type = instagram_bot_addon ? 'ig' : 'fb';

let keyboardQuestionTypeHasValue = '' // eslint-disable-line
let multipleQuestionTypeHasValue = '' // eslint-disable-line

export const userInputFlowSingleModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.user_input_flow_single_modal_title,
    html: userInputFlowSingleHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })

      const customFieldVariableData = {
        url: base_url + 'visual_flow_builder/get_custom_field_variable_dropdown/' + media_type,
      }

      makeAjaxCall(function(response) {
        const optionsArray = response.custom_field_variable_dropdown_array || []
        const html = prepareDropdownLists(optionsArray)
        $('.question-custom-variable .dropdown-menu').html(html)  
      }, customFieldVariableData)

      $('.lead_first_name').on('click', function() {
        var textAreaTxt = $('.emojionearea-editor').html();

        var lastIndex = textAreaTxt.lastIndexOf("<br>");   
        var lastTag = textAreaTxt.substr(textAreaTxt.length - 4); 
        lastTag=lastTag.trim(lastTag);

        if(lastTag=="<br>")
        textAreaTxt = textAreaTxt.substring(0, lastIndex); 

        var txtToAdd = " #LEAD_USER_FIRST_NAME# ";
        var new_text = textAreaTxt + txtToAdd;
        $('.emojionearea-editor').html(new_text);
        $('.emojionearea-editor').trigger('blur');
      });

      $('.lead_last_name').on('click', function() {
        var textAreaTxt = $('.emojionearea-editor').html();
        
        var lastIndex = textAreaTxt.lastIndexOf("<br>");   
        var lastTag = textAreaTxt.substr(textAreaTxt.length - 4); 
        lastTag=lastTag.trim(lastTag);

        if(lastTag=="<br>")
          textAreaTxt = textAreaTxt.substring(0, lastIndex); 
            
        var txtToAdd = ! instagram_bot_addon ? " #LEAD_USER_LAST_NAME# " : " #LEAD_FULL_NAME# ";
        var new_text = textAreaTxt + txtToAdd;
        $('.emojionearea-editor').html(new_text);
        $('.emojionearea-editor').trigger('blur');
      });

      $('.dropdown-menu').on('click', '.dropdown-item', function(event) {
        const selectedText = event.target.innerText

        var textAreaTxt = $('.emojionearea-editor').html()
        
        var lastIndex = textAreaTxt.lastIndexOf("<br>");   
        var lastTag = textAreaTxt.substr(textAreaTxt.length - 4);
        lastTag=lastTag.trim(lastTag)

        if(lastTag=="<br>")
          textAreaTxt = textAreaTxt.substring(0, lastIndex)
        
        var txtToAdd = " #" + selectedText + "# "
        var new_text = textAreaTxt + txtToAdd;
        $('.emojionearea-editor').html(new_text);
        $('.emojionearea-editor').trigger('blur');
      });

      if (oldData.questionType) {
        $('input[name="question-type"][value="' + oldData.questionType + '"]').prop('checked', true)
        $('#question-answer').html(oldData.question || '')
      }

      $("#question-answer").emojioneArea({
        autocomplete: false,
        pickerPosition: "bottom"
      })

      const questionTypeElement = $('input[name="question-type"]')
      const customFieldElement = $('#custom-field')
      const questionFieldsElement = $('#question-fields')

      const questionFieldsMultipleElement = $('#question-fields-multiple')
      const multipleChoiceElements = $('#choices-list .multiple-choice')

      const replyTypeElement = $('#reply-type')

      if (oldData.questionType && 'multiple' === oldData.questionType) {
        multipleChoiceElements.map((index, element) => {
          element.value = oldData.multipleChoices[index] || ''
        })

        if (oldData.multipleChoices 
          && Array.isArray(oldData.multipleChoices)
          && oldData.multipleChoices.length > multipleChoiceElements.length
        ) {
          const choicesListElement = $('#choices-list')

          for (
            let choiceIndex = multipleChoiceElements.length; 
            choiceIndex < oldData.multipleChoices.length; 
            choiceIndex++
          ) {
            const choiceHtml = '' +
              '<div class="col-6 option-wrapper p-1">' +
                '<input type="text" class="form-control multiple-choice" placeholder="' + lang.user_input_flow_single_html_question_another_option_placeholder + '" value="' + oldData.multipleChoices[choiceIndex] + '">' +
                '<span class="option-delete">&times;</span>' +
              '</div>'
      
            choicesListElement.append(choiceHtml)
          }
        }
      }

      if (oldData.replyType) {
        $('#reply-type').val(oldData.replyType || '').trigger('change')
  
        if ('Email' === oldData.replyType) {
          $('#email-quickreply').prop('checked', !!oldData.emailQuickreply)
        } else if ('Phone' === oldData.replyType) {
          $('#phone-quickreply').prop('checked', !!oldData.phoneQuickreply)
        }
      }
      
      $('#system-field').val(oldData.systemField || '').trigger('change')
      $('#skip-button-field').val(oldData.skipButtonText || '')

      function toggleQuestionType(selectedQuestionType, oldData) {
        questionFieldsElement.removeClass('d-none').addClass('d-block')

        if (selectedQuestionType) {
          const selectedReplyType = replyTypeElement.val()
          addSelectOptions(selectedReplyType, selectedQuestionType, oldData)

          if (selectedReplyType) {
            updateCustomField(selectedReplyType, oldData)
          }
        }

        if ('keyboard' === selectedQuestionType) {
          questionFieldsMultipleElement.removeClass('d-block').addClass('d-none')
        } else if ('multiple' === selectedQuestionType) {
          questionFieldsMultipleElement.removeClass('d-none').addClass('d-block')
        } else {
          questionFieldsElement.removeClass('d-block').addClass('d-none')
        }
      }

      const emailWrapperElement = $('#email-quickreply-wrapper')
      const phoneWrapperElement = $('#phone-quickreply-wrapper')

      function toggleReplyType(selectedReplyType, oldData) {
        const selectedQuestionType = $('input[name="question-type"]:checked').val()
        if (selectedQuestionType && selectedReplyType) {
          addSelectOptions(selectedReplyType, selectedQuestionType, oldData)
          updateCustomField(selectedReplyType, oldData)
        }
 
        if (instagram_bot_addon) {
          return
        }

        if ('Email' === selectedReplyType) {
          phoneWrapperElement.removeClass('d-block').addClass('d-none')
          emailWrapperElement.removeClass('d-none').addClass('d-block')
        } else if ('Phone' === selectedReplyType) {
          emailWrapperElement.removeClass('d-block').addClass('d-none')
          phoneWrapperElement.removeClass('d-none').addClass('d-block')
        } else {
          emailWrapperElement
            .add(phoneWrapperElement)
            .removeClass('d-block').addClass('d-none')
        }
      }

      const selectedQuestionType = $('input[name="question-type"]:checked').val()
      toggleQuestionType(selectedQuestionType, oldData)

      questionTypeElement.on('change', function() {
        toggleQuestionType(this.value, oldData)
      })

      const selectedReplyType = replyTypeElement.val()
      toggleReplyType(selectedReplyType, oldData)

      replyTypeElement.on('change', function() {
        toggleReplyType(this.value, oldData)
      })

      const choicesListElement = $('#choices-list')
      const addMoreChoiceElement = $('#add-more-choice')

      addMoreChoiceElement.on('click', function() {
        const choiceHtml = '' +
          '<div class="col-6 option-wrapper p-1">' +
            '<input type="text" class="form-control multiple-choice" placeholder="Another option">' +
            '<span class="option-delete">&times;</span>' +
          '</div>'

        if (choicesListElement.find('div').length >= 11) {
          return;
        }

        choicesListElement.append(choiceHtml)
      })

      $(document).on('click', '.option-wrapper .option-delete', function() {
        $(this).parent().remove()
      })

      const elementLabel = $('#assign-to-labels')
      createSelect2DynamicOption(elementLabel)

      $('[data-toggle="tooltip"]').tooltip()

      const subtypeCreatorWrapperElement = $('#subtype-creator-wrapper')
      const customFieldErrorMessageElement = $('#custom-field-error-message')

      $('#add-custom-custom-field').on('click', function(event) {
        event.preventDefault();

        subtypeCreatorWrapperElement.removeClass('d-none').addClass('d-block')
        customFieldErrorMessageElement.removeClass('d-block').addClass('d-none')
      })

      $('.subtype-creator-close').on('click', function() {
        subtypeCreatorWrapperElement.removeClass('d-block').addClass('d-none')
      })

      $('#save-custom-field').on('click', function() {
        const that = this
        const name = $('#custom-field-name').val()
        const replyType = $('#custom-field-reply-type').val()

        if (!name || !replyType) {
          customFieldErrorMessageElement.removeClass('d-none').addClass('d-block')
          return false;
        } else {
          customFieldErrorMessageElement.removeClass('d-block').addClass('d-none')
        }

        const customFieldData = {
          url: base_url + 'custom_field_manager/ajax_custom_field_insert2',
          data: { 
            name,
            media_type,
            reply_type: replyType,
          }
        }

        $(that).addClass('btn-progress')

        makeAjaxCall(function(response) {
          if (response.id && response.name) {
            customFieldElement.prepend(new Option(response.name, response.id))
          }
          $(that).removeClass('btn-progress')
          subtypeCreatorWrapperElement.removeClass('d-block').addClass('d-none')
        }, customFieldData)
      });
    },

    preConfirm: () => {
      const questionType = $('input[name="question-type"]:checked').val()

      const questionAnswer = $('#question-answer').val()
      const multipleChoices = $('.multiple-choice').map((index, element) => element.value)
      const filledInOptions = multipleChoices.get().filter(n => n !== '')

      const replyType = $('#reply-type').val()
      const replyTypeSelectedOptionText = $('#reply-type option:selected').text()

      const emailQuickreply = $('#email-quickreply').prop('checked')
      const phoneQuickreply = $('#phone-quickreply').prop('checked')

      const customField = $('#custom-field').val()
      const customFieldSelectedOptionText = $('#custom-field option:selected').text()

      const systemField = $('#system-field').val()
      const systemFieldSelectedOptionText = $('#system-field option:selected').text()

      const assignToLabels = $('#assign-to-labels').val()
      const assignToLabelsSelectedOptions = $('#assign-to-labels option:selected')
      
      const assignToMessengerSequence = $('#assign-to-messenger-sequence').val()
      const assignToMessengerSequenceSelectedOptionText = 
        $('#assign-to-messenger-sequence option:selected').text()

      const assignToPhoneSequence = $('#assign-to-email-phone-sequence').val()
      const assignToPhoneSequenceSelectedOptionText = 
        $('#assign-to-email-phone-sequence option:selected').text()
      
      const skipButtonText = $('#skip-button-field').val()

      if(! questionType) {
        Swal.showValidationMessage(lang.user_input_flow_single_modal_msg_question_type)
        return;
      }

      if (! questionAnswer) {
        Swal.showValidationMessage(lang.user_input_flow_single_modal_msg_question)
        return;
      }

      if ('multiple' === questionType) {
        if (filledInOptions.length < 2) {
          Swal.showValidationMessage(lang.user_input_flow_single_modal_msg_multiple_choices)
          return;
        }
      }

      const assignToLabelsSelectedOptionsTextArray = 
        selectedOptionsTextArray(assignToLabelsSelectedOptions)

      return {
        questionType,
        
        question: questionAnswer,
        multipleChoices: filledInOptions,
        
        replyType,
        replyTypeSelectedOptionText,

        emailQuickreply,
        phoneQuickreply,
        
        customField,
        customFieldSelectedOptionText,

        systemField,
        systemFieldSelectedOptionText,
        
        assignToLabels,
        assignToLabelsSelectedOptionsTextArray,

        assignToMessengerSequence,
        assignToMessengerSequenceSelectedOptionText,

        assignToPhoneSequence,
        assignToPhoneSequenceSelectedOptionText,

        skipButtonText,
      }
    },
  })
}

function updateCustomField(selectedReplyType, oldData) {
  const customFieldData = {
    url: base_url + 'custom_field_manager/get_customfield_on_replytype',
    data: { selected_reply_type: selectedReplyType }
  }

  const customFieldElement = $('#custom-field')

  makeAjaxCall(function(response) {
    customFieldElement.html(response.content)
    customFieldElement.prepend(new Option("Please select", ""))
    customFieldElement.val(oldData.customField || '').trigger('change')
  }, customFieldData)
}

function addSelectOptions(selectedReplyType, selectedQuestionType, oldData) {
  const questionData = {
    url: base_url + 'custom_field_manager/ajax_add_question_content_only_options',
    data: { 
      reply_type: selectedReplyType,
      question_category: ('keyboard' === selectedQuestionType) 
        ? 'keyboard_input' 
        : 'multiple_choice',
      page_table_id,
      media_type,
    }
  }

  const elements = {
    customFieldElement: $("#custom-field"),
    assignToLabelsElement: $('#assign-to-labels'),
    assignMessengerSequenceElement: $('#assign-to-messenger-sequence'),
    assignToEmailPhoneSequenceElement: $('#assign-to-email-phone-sequence'),
  }

  // if (('keyboard' === selectedQuestionType) && keyboardQuestionTypeHasValue) {
  //   setSelectOptions(keyboardQuestionTypeHasValue, elements, oldData)
  //   return false
  // } else if (('multiple' === selectedQuestionType) && multipleQuestionTypeHasValue) {
  //   setSelectOptions(multipleQuestionTypeHasValue, elements, oldData)
  //   return false
  // }

  makeAjaxCall(function(response) {
    if ('keyboard' === selectedQuestionType) {
      keyboardQuestionTypeHasValue = response
    } else if ('multiple' === selectedQuestionType) {
      multipleQuestionTypeHasValue = response
    }

    setSelectOptions(response, elements, oldData)
  }, questionData)

  return false
}

function setSelectOptions(response, elements, oldData) {
  elements.customFieldElement.html(response.custom_fileds_content || null)
  elements.customFieldElement.val(oldData.customField || '').trigger('change')

  elements.assignToLabelsElement.html(response.user_labels || null)
  elements.assignToLabelsElement.val(oldData.assignToLabels || '').trigger('change')

  elements.assignMessengerSequenceElement.html(response.messenger_sequence || null)
  elements.assignMessengerSequenceElement
    .val(oldData.assignToMessengerSequence || '')
    .trigger('change')

  elements.assignToEmailPhoneSequenceElement.html(response.email_phone_sequence || null)
  elements.assignToEmailPhoneSequenceElement
    .val(oldData.assignToPhoneSequence || '')
    .trigger('change')
}